module.exports = __webpack_public_path__ + "static/twitter-card-c3d32ce62cdec83a6c1cb8f3b3fd1674.png";